import graphql from 'babel-plugin-relay/macro'
import React, {lazy} from 'react'
import { usePreloadedQuery} from 'react-relay'
import {Redirect, Route, Switch, useRouteMatch} from 'react-router'
import {
  AUTHENTICATION_PAGE,
  BILLING_PAGE,
  MEMBERS_PAGE,
  ORG_SETTINGS_PAGE,
  TEAMS_PAGE
} from '../../../../utils/constants'

import OrgNav from '../Organization/OrgNav'
import OrgTeams from '../OrgTeams/OrgTeams'

const OrgPlansAndBillingRoot = lazy(
  () => import(/* webpackChunkName: 'OrgBillingRoot' */ './OrgPlansAndBillingRoot')
)
const OrgMembers = lazy(
  () =>
    import(/* webpackChunkName: 'OrgMembersRoot' */ '../../containers/OrgMembers/OrgMembersRoot')
)

const OrgDetails = lazy(() => import(/* webpackChunkName: 'OrgDetails' */ './OrgDetails'))
const Authentication = lazy(
  () =>
    import(
      /* webpackChunkName: 'Authentication' */ '../../containers/OrgAuthentication/OrgAuthenticationRoot'
    )
)





const query = graphql`
  query OrganizationQuery($orgId: ID!) {
    viewer {
      organization(orgId: $orgId) {
        id
        ...OrgNav_organization
        ...OrgPlansAndBillingRoot_organization
        ...OrgDetails_organization
        ...OrgTeams_organization
        isBillingLeader
      }
    }
  }
`

const Organization = (props) => {
  const {queryRef} = props
  const {viewer} = usePreloadedQuery(query, queryRef)
  const match = useRouteMatch('/me/organizations/:orgId')
  const {organization} = viewer
  if (!organization) return null
  const {id: orgId, isBillingLeader} = organization

  return (
    React.createElement('section', { className: 'px-4 md:px-8',}
      , React.createElement(OrgNav, { organizationRef: organization,} )
      , React.createElement(Switch, null
        , React.createElement(Route, {
          exact: true,
          path: `${match.url}`,
          render: () => React.createElement(Redirect, { to: `${match.url}/${BILLING_PAGE}`,} ),}
        )
        , React.createElement(Route, {
          exact: true,
          path: `${match.url}/${BILLING_PAGE}`,
          render: () => React.createElement(OrgPlansAndBillingRoot, { organizationRef: organization,} ),}
        )
        , isBillingLeader && (
          React.createElement(Route, {
            exact: true,
            path: `${match.url}/${TEAMS_PAGE}`,
            render: () => React.createElement(OrgTeams, { organizationRef: organization,} ),}
          )
        )
        , React.createElement(Route, {
          exact: true,
          path: `${match.url}/${MEMBERS_PAGE}`,
          render: (p) => React.createElement(OrgMembers, { ...p, orgId: orgId,} ),}
        )
        , React.createElement(Route, {
          exact: true,
          path: `${match.url}/${ORG_SETTINGS_PAGE}`,
          render: (p) => React.createElement(OrgDetails, { ...p, organizationRef: organization,} ),}
        )
        , React.createElement(Route, {
          exact: true,
          path: `${match.url}/${AUTHENTICATION_PAGE}`,
          render: (p) => React.createElement(Authentication, { ...p, orgId: orgId,} ),}
        )
      )
    )
  )
}

export default Organization
